<template>
  <div id="app">
    <router-view></router-view>
 
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      scrollTop: 0, //默认距离顶部的距离
      isShow: false, //控制返回顶部按钮的显隐
      scrollTrigger: false, //默认初始值
    }
  },

}
</script>

<style>
.app{
  padding: 0;
  margin: 0;
}
::-webkit-scrollbar{
      display: none;
    }
</style>
